import React, { useContext, useEffect, useState } from "react";
import { setupSocketErrorHandling } from "../feathers";
import { logContext } from "../logger";
import { useCurrentUserUpdate } from "./CurrentUserContext";

const CLASSNAME = 'SocketErrorContext';
const SocketErrorContext = React.createContext();
const SocketErrorUpdateContext = React.createContext();

export function useSocketError() {
	return useContext(SocketErrorContext);
}
export function useSocketErrorUpdate() {
	return useContext(SocketErrorUpdateContext);
}

export function SocketErrorProvider({ children }) {
	const [socketError, setSocketError] = useState(null);
	const setCurrentUser = useCurrentUserUpdate();

	function updateSocketError(_socketError) {
		//logger.info(`############# updateSocketError ############### ${JSON.stringify(_socketError)}`);
		setSocketError(_socketError);
	}

	useEffect(() => {
		const errorHandler = (error) => {
			logContext(CLASSNAME, 'info', "errorHandler Application:", error)
			if (error !== "ping timeout" && error !== "transport close") {
				setCurrentUser(null);
				setSocketError("Achtung!!! Die Verbindung zum Server konnte nicht hergestellt werden!")
			}
		};
		const successHandler = () => {
			logContext(CLASSNAME, 'info', "successHandler Application reload after socketError:", socketError)
			if (socketError !== null) {
				setSocketError(null);
				window.location.reload();
			}
		};

		setupSocketErrorHandling(errorHandler, successHandler)
	}, [socketError, setCurrentUser]);

	return (
		<SocketErrorContext.Provider value={socketError}>
			<SocketErrorUpdateContext.Provider value={updateSocketError}>
				{children}
			</SocketErrorUpdateContext.Provider>
		</SocketErrorContext.Provider>
	)
}